export const Close = () => {
  $('.js-close>span').on('click', function() {
    $(this).prev().val('');
  });
};
